import { globalActor } from "../../state/GlobalContextProvider";
import { useSelector } from "@xstate/react";
export default function WhatPatients(props) {
  const state = useSelector(globalActor, (snapshot) => snapshot.value);
  return (
    <div className="WhatPatients Screen">
      <div></div>
      <section>
        <h2>WHAT PATIENTS SHOULD KNOW</h2>
        <ul>
          <li>
            <span>
              Each multidose bottle of MIEBO contains a 1-month supply
            </span>
          </li>
          <li>
            <span>
              MIEBO should be administered 4&nbsp;times daily into each eye
            </span>{" "}
          </li>
          <li>
            <span>
              MIEBO should not be administered while wearing contact lenses.
              Contact lenses should be removed before use and for at least 30
              minutes after administration of MIEBO
            </span>
          </li>
          <li>
            <span>
              It is important to follow administration instructions for MIEBO,
              which are found in section 2.2 of the{" "}
              <a
                href="https://www.bausch.com/globalassets/pdf/packageinserts/pharma/miebo-package-insert.pdf"
                target="_blank"
              >
                Prescribing Information
              </a>
            </span>
          </li>
        </ul>
        <p>See more on the MIEBO experience</p>
        <a
          href="https://www.miebo-ecp.com/the-miebo-experience/?utm_source=digital&utm_medium=AR&utm_campaign=MIEBO_Experience_AR"
          target="_blank"
          onClick={(_) => window.gaEvent({ event: "visit_website_clicked" })}
        >
          VISIT WEBSITE
        </a>
      </section>
      <section>
        <footer>
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 662.84 284.95"
          >
            <defs>
              <style>
                {`
      .cls-1 {
        font-family: Poppins-Regular, Poppins;
        font-size: 53.46px;
      }

      .cls-1, .cls-2, .cls-3, .cls-4 {
        fill: #fff;
      }

      .cls-3 {
        opacity: .9;
      }

      .cls-3, .cls-4 {
        isolation: isolate;
      }

      .cls-4 {
        opacity: .6;
      }`}
              </style>
            </defs>
            <g>
              <path
                class="cls-2"
                d="M23.74,51.5H.04V.9h22.1c10.6,0,17.6,5.1,17.6,13.6s-3.3,9.2-7.6,10.8c5.8.8,10.3,6,10.3,11.9,0,9-7.3,14.3-18.7,14.3M18.34,12.2h-2.6v9.4h2.6c4.6,0,6.9-1.6,6.9-4.9.1-3.4-2.4-4.5-6.9-4.5M20.94,30.8h-5.1v9.4h5.1c4.7,0,6.4-1.8,6.4-4.9.1-3.1-2.2-4.5-6.4-4.5"
              />
              <path
                class="cls-2"
                d="M89.24,51.5l-2.7-9.2h-14.8l-2.7,9.2h-16.2L70.34.9h18.3l17.5,50.6h-16.9ZM79.14,17.3l-3.8,12.8h7.6s-3.8-12.8-3.8-12.8Z"
              />
              <path
                class="cls-2"
                d="M142.44,52.3c-14,0-24.5-7.2-24.5-24.1V.9h16.9v29.1c0,5.5,2.9,8.9,7.6,8.9s7.6-3.5,7.6-8.9V.9h16.9v27.3c0,16.9-10.5,24.1-24.5,24.1"
              />
              <path
                class="cls-2"
                d="M201.64,52.3c-8.2,0-15.4-3-20.1-7.1l6.7-10.7c4.7,3.8,8.8,5.5,13.2,5.5s4.2-1.1,4.2-2.8-1.9-3.3-8.1-5.2c-9.2-2.8-13.9-6.8-13.9-15.1C183.64,5.9,192.24.1,204.54.1s13,2.4,16.4,5.1l-6.7,11c-3.5-2.5-6.7-3.8-10.4-3.8s-4.4,1.4-4.4,2.8,1.2,2.6,7.8,4.5c9.1,2.6,14.1,6.2,14.1,15.7.1,10.1-7.5,16.9-19.7,16.9"
              />
              <path
                class="cls-2"
                d="M261.94,52.3c-15.4,0-26.4-10.8-26.4-25.9S246.94.1,262.24.1s13.5,3.5,17.9,7.2l-8.3,11.3c-2.8-2.8-5.5-4.7-9.9-4.7s-9.8,4.9-9.8,12.1,4,12.5,10.8,12.5,7.2-1.7,10.2-4.4l8.1,11c-4.9,4.3-10.4,7.2-19.3,7.2"
              />
              <polygon
                class="cls-2"
                points="326.84 51.5 326.84 33.8 314.14 33.8 314.14 51.5 297.24 51.5 297.24 .9 314.14 .9 314.14 19.5 326.84 19.5 326.84 .9 343.84 .9 343.84 51.5 326.84 51.5"
              />
              <polygon
                class="cls-2"
                points="439.14 51.5 439.14 .9 455.34 .9 455.34 38.6 471.84 38.6 471.84 51.5 439.14 51.5"
              />
              <path
                class="cls-2"
                d="M508.34,52.3c-15.9,0-27.2-11-27.2-26.1S492.54,0,508.44,0s27.2,11,27.2,26.1-11.4,26.2-27.3,26.2M508.34,13.5c-6.2,0-10.6,5.3-10.6,12.6s4.6,12.8,10.7,12.8,10.6-5.3,10.6-12.6-4.5-12.8-10.7-12.8"
              />
              <polygon
                class="cls-2"
                points="587.64 51.5 587.64 26.8 579.74 41.5 572.04 41.5 564.04 26.8 564.04 51.5 548.04 51.5 548.04 .9 564.54 .9 576.04 21.1 586.64 .9 604.54 .9 604.54 51.5 587.64 51.5"
              />
              <path
                class="cls-2"
                d="M644.24,51.5h-23.8V.9h22.1c10.6,0,17.6,5.1,17.6,13.6s-3.3,9.2-7.6,10.8c5.8.8,10.3,6,10.3,11.9,0,9-7.2,14.3-18.6,14.3M638.84,12.2h-2.6v9.4h2.6c4.6,0,6.9-1.6,6.9-4.9s-2.4-4.5-6.9-4.5M641.44,30.8h-5.1v9.4h5.1c4.7,0,6.4-1.8,6.4-4.9s-2.2-4.5-6.4-4.5"
              />
              <rect
                class="cls-2"
                x="383.24"
                y="18"
                width="16.4"
                height="16.4"
              />
              <rect
                class="cls-3"
                x="383.24"
                y=".9"
                width="16.4"
                height="17.1"
              />
              <rect
                class="cls-3"
                x="383.24"
                y="34.4"
                width="16.4"
                height="17.1"
              />
              <rect
                class="cls-4"
                x="366.14"
                y="18"
                width="17.2"
                height="16.4"
              />
              <rect
                class="cls-4"
                x="399.64"
                y="18"
                width="17.1"
                height="16.4"
              />
            </g>
            <text class="cls-1" transform="translate(0 171.37)">
              <tspan x="0" y="0">
                ©2026 Bausch + Lomb
              </tspan>
              <tspan x="0" y="83">
                MBO.0327.USA.24 V2
              </tspan>
            </text>
          </svg>
        </footer>
      </section>
    </div>
  );
}
